import _ from 'lodash';
import * as actionTypes from './types';
import * as api from '../../api/base';
import { endpoints } from '../../api/endpoints';
import store from '..';
import { payloadAction } from '../utility'
import { setReportId } from '../appAction';
import { ReportStatus } from '../../helpers/reportResultsHelper';
import { getErrorMessage, getExceptionMessage } from '../../helpers/apiHelper';

export const getAllSectors = () => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farmReport.lookup.sectors);
    if (response && response.status === 200) {
      return dispatch(
        payloadAction(response?.data, actionTypes.GET_ALL_SECTORS_SUCCESS)
      );
    } else {
      return dispatch(
        payloadAction(getErrorMessage(response), actionTypes.GET_ALL_SECTORS_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.GET_ALL_SECTORS_FAIL));
  }
};

export const getProjects = () => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farmReport.projects);
    if (response && response.status === 200) {
      return dispatch(
        payloadAction(response?.data, actionTypes.GET_PROJECTS_SUCCESS)
      );
    }
    else {
      return dispatch(
        payloadAction(getErrorMessage(response), actionTypes.GET_PROJECTS_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.GET_PROJECTS_FAIL)
    );
  }
};

export const getTypesBySector = ({ sectorId }) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farmReport.lookup.types.concat('?sectorId=', sectorId));
    if (response && response.status === 200) {
      return dispatch(
        payloadAction(response?.data, actionTypes.GET_TYPES_BY_SECTOR_SUCCESS)
      );
    }
    else {
      return dispatch(
        payloadAction(getErrorMessage(response), actionTypes.GET_TYPES_BY_SECTOR_FAIL)
      );
    }
  }
  catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.GET_TYPES_BY_SECTOR_FAIL));
  }
};

export const getSystemsBySector = ({ sectorId }) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farmReport.lookup.systems.concat('?sectorId=', sectorId));
    if (response && response.status === 200) {
      return dispatch(
        payloadAction(response?.data, actionTypes.GET_SYSTEMS_BY_SECTOR_SUCCESS)
      );
    }
    else {
      return dispatch(
        payloadAction(getErrorMessage(response), actionTypes.GET_SYSTEMS_BY_SECTOR_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.GET_SYSTEMS_BY_SECTOR_FAIL));
  }
};

export const getSectorItemsBySector = ({ sectorId }) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farmReport.lookup.sectorItems.concat('?sectorId=', sectorId));
    if (response && response.status === 200) {
      return dispatch(
        payloadAction(response?.data, actionTypes.GET_SECTOR_ITEMS_BY_SECTOR_SUCCESS)
      );
    }
    else {
      return dispatch(
        payloadAction(getErrorMessage(response), actionTypes.GET_SECTOR_ITEMS_BY_SECTOR_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.GET_SECTOR_ITEMS_BY_SECTOR_FAIL));

  }
};

export const createTempFarmReportSectors = (response) => {
  return {
    type: actionTypes.CREATE_TEMP_FARM_REPORT_SECTORS,
    payload: response
  };
};

export const addNewFarmReportSector = (response) => {
  return {
    type: actionTypes.ADD_NEW_FARM_REPORT_SECTOR,
    payload: response
  };
};

export const addRemoveFarmReportSector = (response) => {
  return {
    type: actionTypes.ADD_REMOVE_FARM_REPORT_SECTOR,
    payload: response
  };
};

export const addFarmReportGroup = (response) => {
  return {
    type: actionTypes.ADD_FARM_REPORT_GROUP,
    payload: response
  };
};

export const removeFarmReportGroup = (response) => {
  return {
    type: actionTypes.REMOVE_FARM_REPORT_GROUP,
    payload: response
  };
};

export const editFarmReportGroup = (response) => {
  return {
    type: actionTypes.EDIT_FARM_REPORT_GROUP,
    payload: response
  };
};

export const addFarmReportSectorItem = (response) => {
  return {
    type: actionTypes.ADD_FARM_REPORT_SECTOR_ITEM,
    payload: response
  };
};

export const removeFarmReportSectorItem = (response) => {
  return {
    type: actionTypes.REMOVE_FARM_REPORT_SECTOR_ITEM,
    payload: response
  };
};

const updateReportSettingsStore = async (settingsData, dispatch, type) => {
  let config = settingsData?.reportConfiguration || {}
  let reportSettingsRefined = {
    ...settingsData,
    locked: !ReportStatus.canEdit(settingsData?.status, settingsData?.accessLevel),
    landAndCropsOnly: !config?.isLivestockSectorsAdded && config?.isLandAreaSectorsAdded,
    livestockOnly: config?.isLivestockSectorsAdded && !config?.isLandAreaSectorsAdded,
    sectorConfigurations: _.orderBy(config.sectorConfigurations, 'enterpriseSectorId', 'asc')
  };
  dispatch(setReportId(settingsData?.reportId))
  return dispatch({
    type: type,
    payload: reportSettingsRefined
  });
}

export const getFarmReport = ({ reportId }) => async (dispatch) => {

  if (!reportId) {
    return dispatch(
      payloadAction(getErrorMessage('Cannot get unknown report!'), actionTypes.GET_FARM_REPORT_SETTINGS_FAIL)
    );
  }
  try {
    const settingsResponse = await api.get(endpoints.farmReport.settings.concat('/', reportId));

    if (settingsResponse && settingsResponse.status === 200 && settingsResponse?.data) {
      return updateReportSettingsStore( settingsResponse?.data || {},
                                        dispatch,
                                        actionTypes.GET_FARM_REPORT_SETTINGS_SUCCESS
                                      );
    } else {
      return dispatch(
        payloadAction(getErrorMessage(settingsResponse), actionTypes.GET_FARM_REPORT_SETTINGS_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.GET_FARM_REPORT_SETTINGS_FAIL));
  }
};

export const submitFarmReport = () => async (dispatch) => {
  try {
    const { reportSettings } = store.getState().farmReport
    const { farmId } = store.getState().adminFarm

    if (!farmId || farmId===''){
      throw Error('Invalid state, missing farm. Try to refresh this page. If the error persists please visit our Support page.')
    }
    if (!reportSettings?.farmId) {
      reportSettings.farmId = farmId
    }
    const settingsResponse = await api.post( endpoints.farmReport.settings, reportSettings);

    if (settingsResponse?.status === 200) {
      let updatedSettings = settingsResponse?.data || {}
      return updateReportSettingsStore( updatedSettings, 
                                        dispatch, 
                                        actionTypes.SUBMIT_FARM_REPORT_SUCCESS
                                      );
    } else {
      return dispatch(
        payloadAction(getErrorMessage(settingsResponse), actionTypes.RESPONSE_STATE_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.RESPONSE_STATE_FAIL));
  }
};

export const updateFarmReport = () => async (dispatch) => {
  try {
    const { reportSettings } = store.getState().farmReport

    const settingsResponse = await api.put( endpoints.farmReport.settings.concat('/', reportSettings?.reportId), reportSettings );

    if (settingsResponse?.status === 200) {
      let updatedSettings = settingsResponse?.data || {}
      return updateReportSettingsStore( updatedSettings,
                                        dispatch,
                                        actionTypes.UPDATE_FARM_REPORT_SUCCESS
                                      );
    } else {
      return dispatch(
        payloadAction(getErrorMessage(settingsResponse), actionTypes.RESPONSE_STATE_FAIL)
      );
    }
  } catch (e) {
    return dispatch(
      payloadAction(getExceptionMessage(e), actionTypes.RESPONSE_STATE_FAIL));
  }
};

export const editFarmReportSettings = (response) => {
  return {
    type: actionTypes.EDIT_FARM_REPORT_DETAILS,
    payload: response
  };
}

export const resetFarmReportSettings = () => {
  return {
    type: actionTypes.RESET_FARM_REPORT_DETAILS,
  };
}
